import styled from '@emotion/styled';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import mq from '../../../../styleUtility/mediaquery';
import { EditingProjectStateErrors } from '../../../../types/EditingProjectState';
import { useGetAssetFormErrors } from '../../hooks/useGetAssetFormErrors';

type Props = {
  errors: EditingProjectStateErrors;
};

const AssetFormErrorMessages: FC<Props> = ({ errors }) => {
  const assetFormErrors = useGetAssetFormErrors(errors);

  return (
    <ErrorMessageWrap>
      <ErrorMessage>
        {Object.keys(errors.creativeBriefValueEmptyErrors).length ? (
          <FormattedMessage id="creative_brief_editor.field.validation_error.has_no_required_value" />
        ) : null}
      </ErrorMessage>
      {assetFormErrors &&
        assetFormErrors.map((assetFormError, index) => {
          return (
            <ErrorMessage key={index}>
              <FormattedMessage id={assetFormError} />
            </ErrorMessage>
          );
        })}
    </ErrorMessageWrap>
  );
};

const ErrorMessageWrap = styled.div`
  margin-top: 32px;
  text-align: right;
  color: rgb(255, 0, 0);
`;

const ErrorMessage = styled.div`
  margin: 8px 0;

  ${mq('sp')} {
    white-space: pre-wrap;
  }
`;

export default AssetFormErrorMessages;
